
// FancyDressActivity
import React from 'react';
import FieldTrip42025 from 'views/FieldTrip42025';

const FancyDressActivityPage = () => {
  return <FieldTrip42025/>;
};

export default FancyDressActivityPage;